import * as packagejson from "package.json";
import videojs from "video.js";
import initPlayerOverlay from "./overlay.js";

// Default options for the plugin.
const defaults = {
  html: "no informations",
  radioResize: false,
};
const registerPlugin = videojs.registerPlugin || videojs.plugin;
const videoJsButtonClass = videojs.getComponent("Button");
const videoJsComponentClass = videojs.getComponent("Component");

const onPlayerReady = (player, options) => {
  let html;

  if (options.default) {
    // <img src="${options.logo}" width="74" height="42"></img>
    html = `<div style="display:inline-block; height: 100px; width: 200px; vertical-align: top;"><p>
    </p><p style="color:white;font-size:small;line-height: 20px;">${
      options.title
    }</p><p style="font-size:small;"><a href="${
      options.href
    }" target="_blank" style="color:white;font-size:small;">${
      options.link
    }</a></p><p style="font-size:small;">${options.more ||
      "&nbsp;"}</p></div><div style="display:inline-block; height: 100px; width: 160px;"><p><img src="//easybroadcast.fr/img/logo_blue.svg" width="42" height="42" style="width:60px"></img></p><p style="color:white;font-size:small;">EasyBroadcast 2.0.0</p><p style="color:white;font-size:small;">Copyright 2019</p><p style="color:white;font-size:small;">player : videojs 
      ${packagejson.dependencies["video.js"].replace(/\^/, "")}</p></div>`;
    // html = '<div style="left:20px;width: 45%;position: absolute;display:inline-block;height: 80%;overflow-y: scroll;"><p style="color:white;font-size:small;">'+options.title+'</p><p style="font-size:small;"><a href="'+options.href+'" target="_blank" style="color:white;font-size:small;">'+options.link+'</a></p><p style="font-size:small;">'+more+'</p></div><div style="display:inline-block; height: 80%;overflow-y: scroll; width: 160px;margin-left:180px;"><p><img src="//easybroadcast.fr/img/logo_blue.svg" width="42" height="42" style="width:60px"></img></p><p style="color:white;font-size:small;">EasyBroadcast 1.3.0</p><p style="color:white;font-size:small;">Copyright 2018</p><p style="color:white;font-size:small;">player : videojs 5.11</p></div>';
  } else {
    html = { options };
  }

  const content = {
    name: "info",
    el: videoJsComponentClass.prototype.createEl("div", {
      className: "vjs-informationoverlay",
      innerHTML: `<div class="vjs-informationoverlay-content"><span class="vjs-informationoverlay-text">${
        html
      }</span></div>`,
    }),
  };

  initPlayerOverlay(player, content);

  const InfoButtonClass = videojs.extend(videoJsButtonClass, {
    constructor(player) {
      videoJsButtonClass.call(this, player);
    },
    handleClick() {
      player.overlay.toggle("info");
    },
  });

  const infoB = player.addChild(new InfoButtonClass(this));

  infoB.addClass("vjs-infoButton");
  infoB.addClass("vjs-control-bar");

  const infoButtonEl = document.getElementsByClassName("vjs-infoButton")[0];
  infoButtonEl.style.position = "absolute";
  infoButtonEl.style.float = "right";
  if (options.radioResize) {
    infoButtonEl.style.right = "67px";
  } else {
    infoButtonEl.style.right = "20px";
  }
  infoButtonEl.style.left = "auto";
  infoButtonEl.style.top = "8px";
  infoButtonEl.style.zIndex = "10";
  infoButtonEl.style.height = "32px";
  infoButtonEl.style.width = "32px";
  infoButtonEl.style.backgroundImage =
    "url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMDAgMTAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48Zz48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNNTAsMTIuNWMtMjAuNywwLTM3LjUsMTYuOC0zNy41LDM3LjVjMCwyMC43LDE2LjgsMzcuNSwzNy41LDM3LjVTODcuNSw3MC43LDg3LjUsNTBDODcuNSwyOS4zLDcwLjcsMTIuNSw1MCwxMi41eiBNNTMuOCw3MC45YzAsMC43LTAuNiwxLjMtMS4zLDEuM2gtNWMtMC43LDAtMS4zLTAuNi0xLjMtMS4zVjQ2LjZjMC0wLjcsMC42LTEuMywxLjMtMS4zaDVjMC43LDAsMS4zLDAuNiwxLjMsMS4zVjcwLjl6IE01MCwzOS45Yy0yLjUsMC00LjUtMi00LjUtNC42YzAtMi41LDItNC41LDQuNS00LjVjMi41LDAsNC42LDIsNC42LDQuNUM1NC41LDM3LjksNTIuNSwzOS45LDUwLDM5Ljl6Ii8+PC9nPjwvc3ZnPgo=)";
  infoButtonEl.style.setProperty(
    "background-color",
    "transparent",
    "important",
  );
  infoButtonEl.style.backgroundRepeat = "no-repeat";
  infoButtonEl.style.backgroundSize = "contain";
  infoButtonEl.style.cursor = "pointer";
  infoButtonEl.style.opacity = 0.8;

  infoButtonEl.onmouseover = function() {
    // this.style.filter = 'drop-shadow(0px 0px 2px white)';
    this.style.opacity = 1;
  };
  infoButtonEl.onmouseleave = function() {
    this.style.opacity = 0.8;
  };

  const infoContent = document.getElementsByClassName(
    "vjs-informationoverlay-content",
  )[0];
  infoContent.style.height = "40%";
  if (window.matchMedia("(max-width: 1100px)").matches) {
    infoContent.style.height = "75%";
  }
  infoContent.style.top = "0";
  infoContent.style.right = "0";
  infoContent.style.bottom = "0";
  infoContent.style.left = "0";
  infoContent.style.margin = "auto";
  infoContent.style.position = "absolute";
  infoContent.style.textAlign = "center";
};

/**
 * An EasyBroadcast video.js plugin.
 *
 * Information button
 *
 */
function infoButton(options = defaults) {
  if (
    this.plugins &&
    this.plugins.videojs_radio &&
    this.plugins.videojs_radio.resize
  ) {
    options.radioResize = true;
  }
  this.ready(() => {
    onPlayerReady(this, videojs.mergeOptions(defaults, options));
  });
}

// Register the plugin with video.js.
registerPlugin("infoButton", infoButton);

// Include the version number.
infoButton.VERSION = "0.9";

export default infoButton;



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/ui/videojs-info-button.js